<template>
  <div class="noapply">
    <div class="main-width">
      <div class="noapply-title m_t45">{{ currentData.title }}</div>
      <div class="noapply-branch m_t20">责任部门: {{ currentData.depart }}</div>
      <div class="noapply-banner-wrapper m_t30">
        <div
          class="noapply-banner"
          v-for="(banner, bannerIndex) in bannerList"
          :key="banner.ref"
        >
          <div class="noapply-banner-title m_t30 m_b30 font-bold">
            {{ banner.label }}
          </div>
          <div class="noapply-banner-content">
            <template v-if="banner.ref === 'addition'">
              <div
                class="condition-wrapper"
                v-for="(condition, conditionIndex) in banner.value"
                :key="conditionIndex"
              >
                <i
                  v-if="condition.status === 'true'"
                  class="el-icon-check m_r10"
                ></i>
                {{ conditionIndex + 1 + "、" + condition.label }}
              </div>
            </template>
            <template v-else-if="banner.ref === 'content'">
              <div>{{ banner.value.label }}</div>
              <div class="banner-form m_t30">
                <div class="banner-form-label">
                  银行账户信息<i
                    class="el-icon-edit-outline pointer color_blue m_l20"
                    @click="showAccount"
                  ></i>
                </div>
                <div class="banner-form-content m_t20">
                  <el-form @submit.native.prevent>
                    <el-row :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="收款单位全称：">{{
                          banner.value.form.unitname
                        }}</el-form-item>
                      </el-col>
                      <el-col :span="16">
                        <el-form-item label="统一社会信用代码："
                          >{{ banner.value.form.socialId }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="账号："
                          >{{ banner.value.form.actname }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="开户名："
                          >{{ banner.value.form.bank }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="开户银行："
                          >{{ banner.value.form.bankname }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="联系人："
                          >{{ banner.value.form.contact }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="16">
                        <el-form-item label="联系电话："
                          >{{ banner.value.form.phone }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="会计："
                          >{{ banner.value.form.accounting }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="16">
                        <el-form-item label="出纳："
                          >{{ banner.value.form.cashier }}
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-else-if="banner.ref === 'promise'">
              <el-checkbox v-model="checked"
                >阅读并同意<el-button type="text" @click="showPromise"
                  >《信用承诺书》</el-button
                ></el-checkbox
              >
            </template>
            <template v-else>
              {{ banner.value }}
            </template>
          </div>
        </div>
        <div class="noapply-btns tc">
          <el-button @click="$router.go(-1)" v-if="nobtn != 1"
            >放弃兑现</el-button
          >
          <el-button @click="confirm" type="primary" v-if="nobtn != 1"
            >确认兑现</el-button
          >
          <el-button @click="$router.go(-1)">返回</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="promiseVisible"
      class="dialog"
      :visible.sync="promiseVisible"
      @close="handleClosePromise"
      width="40%"
      :before-close="handleClosePromise"
    >
      <template #title> <div class="tc font-36">信用承诺书</div></template>
      <div class="wrapper">
        <!-- <div class="font-bold font-20">本公司承诺:</div>
				<div class="font-20 m_t20 lh1_5">
					&nbsp;&nbsp;我公司（单位）不属于失信被执行人、联合惩戒、重大税收违反对象；企业及法定代表人从未参与涉黑涉恶违法犯罪。如若违反以上承诺，我公司（单位）愿意承担由此造成的一切法律责任。我公司（单位）授权并统一市工业和信息化局查询我公司（单位）申报本次扶持政策所需要的信用报告等相关资信情况
				</div> -->
        <div class="font-16 m_t10 lh_2 indent_2">
          为加快推进全国，加强企业诚信自律，逐步建立企业诚信经营长效机制，营造诚实守信的信用环境，树立诚信守法经营形象。我单位
          <span class="under-line">{{ roleBasic.unitName || "" }}</span
          >，统一社会信用代码为
          <span class="under-line">{{ roleBasic.unitSoleNumber || "" }}</span
          >，郑重承诺如下：
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （一）严格遵守国家法律、法规、规章和政策规定，依法从事生产经营活动。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （二）自觉接受政府、行业组织、社会公众、新闻舆论的监督，积极履行社会责任。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （三）自我约束、自我管理，守合同、重信用，不制假售假、商标侵权、虚假宣传、违约毁约、恶意逃债、偷税漏税、价格欺诈、垄断和不正当竞争，切实维护消费者的合法权益。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （四）发生违法失信行为，依照有关法律、行政法规规定接受行政执法部门给予的行政处罚、约束和惩戒，并依法承担相应责任。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （五）本《信用承诺书》同意向社会公开。
        </div>
        <div class="footer-box m_t20">
          <div class="flex-end end-box">
            <div class="font-16 m_t10 lh1_5 flex-width">
              <span>承诺单位：</span>
              <span class="text-box">{{ roleBasic.unitName || "" }}</span>
            </div>
          </div>
          <div class="flex-end end-box">
            <div class="font-16 m_t10 lh1_5 flex-width">
              <span>法定代表人：</span>
              <span class="text-box">{{ roleBasic.legalName || "" }}</span>
            </div>
          </div>

          <div class="font-16 m_t10 lh1_5">{{ currentTime }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePromise()">取 消</el-button>
        <el-button
          type="primary"
          @click="
            handleClosePromise();
            checked = true;
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      v-if="actVisible"
      title="编辑银行账户信息"
      class="dialog"
      :visible.sync="actVisible"
      @close="handleCloseAccount"
      width="60%"
      :before-close="handleCloseAccount"
    >
      <div class="banner-form">
        <div
          class="banner-form-label"
          style="padding-bottom: 0;padding-top: 20px;"
        >
          <el-form @submit.native.prevent>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="收款单位全称"
                  >{{ actForm.unitname }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统一社会信用代码"
                  >{{ actForm.socialId }}
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="开户名">{{ actForm.bank }} </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="banner-form-content m_t20">
          <el-form @submit.native.prevent>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="账号"
                  ><el-input v-model="actForm.actname"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户银行"
                  ><el-input v-model="actForm.bankname"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人"
                  ><el-input v-model="actForm.contact"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话"
                  ><el-input v-model="actForm.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会计"
                  ><el-input v-model="actForm.accounting"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出纳"
                  ><el-input v-model="actForm.cashier"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAccount()">取 消</el-button>
        <el-button type="primary" @click="confirmAct()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deepClone } from "@/common/utils";
import { mapActions, mapGetters } from "vuex";
const allData = [
  {
    id: 1,
    depart: "工业和信息化局",
    type: "资金补助",
    title: "2021年度中小企业成长支持资金-贷款贴息",
    deadline: "2021/12/30",
  },
  {
    id: 2,
    depart: "工业和信息化局",
    type: "资金补助",
    title: "2021年度中小企业成长支持资金-直接融资",
    deadline: "2021/12/30",
  },
  {
    id: 3,
    depart: "财政部",
    type: "资金补助",
    title: "支持中小微企业",
    deadline: "2021/12/30",
  },
  {
    id: 4,
    depart: "工业和信息化局",
    type: "资质认定",
    title: "第三批工信部专精特新“小巨人”奖励",
    deadline: "2021/12/30",
  },
  {
    id: 5,
    depart: "工业和信息化局",
    type: "资金补助",
    title: "支持高端制造",
    deadline: "2021/12/30",
  },
  {
    id: 6,
    depart: "科技局",
    type: "资质认定",
    title: "2021年度市级高新技术企业备案奖励",
    deadline: "2021/12/30",
  },
  {
    id: 7,
    depart: "工业和信息化局",
    type: "资质认定",
    title: "第六批工信部制造业单项冠军奖励",
    deadline: "2021/12/30",
  },
  {
    id: 8,
    depart: "市场监督管理局",
    type: "资质认定",
    title: "政府质量奖（第七届）奖励",
    deadline: "2021/11/30",
  },
  {
    id: 9,
    depart: "市商务局",
    type: "资金补助",
    title: "促进传统消费（中华老字号、福建老字号）奖励",
    deadline: "2021/11/30",
  },
  {
    id: 10,
    depart: "市场监督管理局",
    type: "资质认定",
    title: "中国质量奖（第四届）奖励",
    deadline: "2021/11/30",
  },
  {
    id: 11,
    depart: "农业农村局",
    type: "资质认定",
    title: "2020年度家庭农场示范场奖励",
    deadline: "2021/11/30",
  },
  {
    id: 12,
    depart: "市文发办",
    type: "资质认定",
    title: "2020-2021年度市重点文化企业奖励",
    deadline: "2021/10/30",
  },
  {
    id: 13,
    depart: "市商务局",
    type: "资质认定",
    title: "2021年国家级数字商务示范企业奖励",
    deadline: "2021/10/30",
  },
  {
    id: 14,
    depart: "市商务局",
    type: "资质认定",
    title: "能源管理体系建设项目奖励",
    deadline: "2021/10/30",
  },
  {
    id: 15,
    depart: "工业和信息化局",
    type: "资质认定",
    title: "省级绿色制造名单奖励",
    deadline: "2021/9/30",
  },
];
export default {
  data() {
    return {
      checked: false,
      currentData: allData[this.$route.params.id - 1],
      bannerList: [
        {
          ref: "addition",
          label: "兑现条件",
          value: [
            {
              label:
                "获得省级绿色制造示范试点的企业和产品，包括省级绿色工厂、绿色设计产品、绿色园区、绿色供应链管理等荣誉称号",
              status: "true",
            },
          ],
        },
        {
          ref: "content",
          label: "扶持内容",
          value: {
            label:
              "参加过中洁网联合市卫厨行业协会、万翔网商、卫厨企业建设的卫厨产品线上展销平台。对单家企业提供不超过2万元的展位费补助",
            form: {
              unitname: "光速迭代科技（北京）有限公司",
              socialId: "91110108MA0013MU6D",
              actname: "11102938393930",
              bank: "光速迭代科技（北京）有限公司",
              bankname: "中国工商银行(黄石天津路支行)",
              contact: "鞠庆煌",
              phone: "13098765435",
              accounting: "鞠庆煌",
              cashier: "李天龙",
            },
          },
        },
        {
          ref: "sale",
          label: "金额",
          value: "100万元",
        },
        {
          ref: "promise",
          label: "承诺函",
        },
      ],
      actForm: {
        unitname: "光速迭代科技（北京）有限公司",
        socialId: "91110108MA0013MU6D",
        actname: "11102938393930",
        bank: "光速迭代科技（北京）有限公司",
        bankname: "中国工商银行(黄石天津路支行)",
        contact: "鞠庆煌",
        phone: "13098765435",
        accounting: "鞠庆煌",
        cashier: "李天龙",
      },
      promiseVisible: false,
      actVisible: false,
      nobtn: 0,
      // 当前年月日
      currentTime: "",
    };
  },
  computed: mapGetters({
    roleBasic: "roleBasic",
  }),
  created() {
    this.setCurrentTime();
    this.nobtn = this.$route.query.nobtn;
    if (this.$route.params.id == 1) {
      this.bannerList = [
        {
          ref: "addition",
          label: "兑现条件",
          value: [
            {
              label:
                "获得 “2020-2021年度长型中小微企业”认定，且上一年度未获得本项贷款利息补助的企业。",
              status: "true",
            },
            {
              label:
                "符合条件的发行 集合债券、集合票据、短期融资券、私募债券或者通过 集合信托等方式进行直接融资的企业。",
              status: "true",
            },
            {
              label:
                "银行 贷款贴息项目，要求贷款为本币 流动资金贷款和 固定资产贷款，补助在 2020年1月1日至2020年12月31日期间正常履行贷款产生的利息。",
              status: "true",
            },
          ],
        },
        {
          ref: "content",
          label: "扶持内容",
          value: {
            label:
              "贷款贴息额度主要根据每个企业的信用评级和年度实际支付的利息，给予最高不超过 50%的银行贷款利息补助，每个企业每年贴息额度不超过 10万元。",
            form: {
              unitname: "光速迭代科技（北京）有限公司",
              socialId: "91110108MA0013MU6D",
              actname: "11102938393930",
              bank: "光速迭代科技（北京）有限公司",
              bankname: "中国工商银行(黄石天津路支行)",
              contact: "鞠庆煌",
              phone: "13098765435",
              accounting: "鞠庆煌",
              cashier: "李天龙",
            },
          },
        },
        {
          ref: "sale",
          label: "金额",
          value: "100万元",
        },
        {
          ref: "promise",
          label: "承诺函",
        },
      ];
    } else if (this.$route.params.id == 2) {
      this.bannerList = [
        {
          ref: "addition",
          label: "兑现条件",
          value: [
            {
              label:
                "获得 “2020-2021年度长型中小微企业”认定，且上一年度未获得本项贷款利息补助的企业。",
              status: "true",
            },
            {
              label:
                "符合条件的发行 集合债券、集合票据、短期融资券、私募债券或者通过 集合信托等方式进行直接融资的企业。",
              status: "true",
            },
            {
              label:
                "直接 融资借款项目，融资合同签订日期为 2020年1月1日至2020年12月31日。",
              status: "true",
            },
          ],
        },
        {
          ref: "content",
          label: "扶持内容",
          value: {
            label:
              "贷款贴息额度主要根据每个企业的信用评级和年度实际支付的利息，给予最高不超过 50%的银行贷款利息补助，每个企业每年贴息额度不超过 10万元。",
            form: {
              unitname: "光速迭代科技（北京）有限公司",
              socialId: "91110108MA0013MU6D",
              actname: "11102938393930",
              bank: "光速迭代科技（北京）有限公司",
              bankname: "中国工商银行(黄石天津路支行)",
              contact: "鞠庆煌",
              phone: "13098765435",
              accounting: "鞠庆煌",
              cashier: "李天龙",
            },
          },
        },
        {
          ref: "sale",
          label: "金额",
          value: "100万元",
        },
        {
          ref: "promise",
          label: "承诺函",
        },
      ];
    } else {
      this.bannerList = [
        {
          ref: "addition",
          label: "兑现条件",
          value: [
            {
              label:
                "获得省级绿色制造示范试点的企业和产品，包括省级绿色工厂、绿色设计产品、绿色园区、绿色供应链管理等荣誉称号",
              status: "true",
            },
          ],
        },
        {
          ref: "content",
          label: "扶持内容",
          value: {
            label:
              "参加过中洁网联合市卫厨行业协会、万翔网商、卫厨企业建设的卫厨产品线上展销平台。对单家企业提供不超过2万元的展位费补助",
            form: {
              unitname: "光速迭代科技（北京）有限公司",
              socialId: "91110108MA0013MU6D",
              actname: "11102938393930",
              bank: "光速迭代科技（北京）有限公司",
              bankname: "中国工商银行(黄石天津路支行)",
              contact: "鞠庆煌",
              phone: "13098765435",
              accounting: "鞠庆煌",
              cashier: "李天龙",
            },
          },
        },
        {
          ref: "sale",
          label: "金额",
          value: "100万元",
        },
        {
          ref: "promise",
          label: "承诺函",
        },
      ];
    }
  },
  methods: {
    // 设置当前时间
    setCurrentTime() {
      let date = new Date();
      this.currentTime =
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1) +
        "月" +
        date.getDate() +
        "日";
    },
    confirmAct() {
      const _bannerList = deepClone(this.bannerList);
      _bannerList[1].value.form = this.actForm;
      this.bannerList = _bannerList;
      this.handleCloseAccount();
    },
    confirm() {
      this.$confirm("确认兑现?")
        .then((_) => {
          this.$message.success("兑现成功");
        })
        .catch((_) => {
          this.$message.warning("取消兑现");
        });
    },
    showAccount() {
      this.actForm = deepClone(this.bannerList[1].value.form);
      this.actVisible = true;
    },
    handleCloseAccount() {
      this.actVisible = false;
    },
    showPromise() {
      this.promiseVisible = true;
    },
    handleClosePromise() {
      this.promiseVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content,
/deep/.el-form-item__label {
  font-size: 16px;
}
.banner-form {
  border: 1px solid #eee;
  &-label {
    display: flex;
    background: #f6f8fa;
    color: #333;
    font-weight: bold;
    padding: 10px 20px;
    border: 1px solid #eee;
  }
  &-content {
    padding: 20px 20px 0;
  }
}
.noapply-title {
  text-align: center;
  font-size: 36px;
  font-weight: 500;
  color: #333;
  margin-top: 34px;
}
.noapply-branch {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #aaa;
}
.noapply-banner-title {
  position: relative;
  font-size: 20px;
  padding-left: 20px;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0.5px;
    width: 3px;
    height: calc(100% - 1px);
    background: $blue;
  }
}
.el-icon-check {
  color: $green;
  padding: 2px;
  border-radius: 50%;
  border: 1px solid $green;
}
.condition-wrapper {
  margin-bottom: 10px;
}
/deep/ .el-dialog__body {
  padding: 20px 60px 30px;
}
/deep/ .el-dialog__footer {
  padding: 10px 60px 30px;
}
.wrapper {
  .under-line {
    display: inline-block;
    min-width: 80px;
    position: relative;
    text-indent: 0;
    margin: 0 10px;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      border: 1px solid #b1aeae;
      left: 0;
      bottom: -2px;
    }
  }
  .indent_2 {
    text-indent: 2em;
  }
  .lh_2 {
    line-height: 2;
  }
  .footer-box {
    text-align: right;
    // .text-box{
    // 	display: inline-block;
    // 	min-width: 100px;
    // }
    // .flex-end{
    // 	display: flex;
    // 	justify-content: end;
    // }
    .end-box {
      display: flex;
      justify-items: end;

      .flex-width {
        width: 40%;
        text-align: left;
        display: flex;
        .text-box {
          flex: 1;
        }
      }
    }
  }
}
</style>
